/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SalesforceConfigurationConductor_QueryVariables = {};
export type SalesforceConfigurationConductor_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"SalesforceConfigurationConductor_viewer">;
    } | null;
};
export type SalesforceConfigurationConductor_Query = {
    readonly response: SalesforceConfigurationConductor_QueryResponse;
    readonly variables: SalesforceConfigurationConductor_QueryVariables;
};



/*
query SalesforceConfigurationConductor_Query {
  viewer {
    actualPersonId
    component(name: "salesforce_configuration_conductor")
    ...SalesforceConfigurationConductor_viewer
    id
  }
}

fragment SalesforceConfigurationConductor_viewer on Viewer {
  company {
    newSalesforceEnabled
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "salesforce_configuration_conductor"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"salesforce_configuration_conductor\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforceConfigurationConductor_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SalesforceConfigurationConductor_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SalesforceConfigurationConductor_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newSalesforceEnabled",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "SalesforceConfigurationConductor_Query",
    "operationKind": "query",
    "text": "query SalesforceConfigurationConductor_Query {\n  viewer {\n    actualPersonId\n    component(name: \"salesforce_configuration_conductor\")\n    ...SalesforceConfigurationConductor_viewer\n    id\n  }\n}\n\nfragment SalesforceConfigurationConductor_viewer on Viewer {\n  company {\n    newSalesforceEnabled\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '2a7ec06a9f7f6df4887082f7adf035c8';
export default node;
